import React from "react";

import Button from "../../Button";
import { NoticeContent } from "../../../services/NoticeService";
import Modal from "../Modal";
import NoticeText from "./NoticeText";

interface Props {
  notice: NoticeContent;
  open: boolean;
  onClose(): void;
}

export default function NoticeDialog({ notice, open, onClose }: Props) {
  const { action } = notice;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={notice.title}
      icon="campaign"
      size="medium"
      closeLabel="Fechar aviso"
      actions={(
        <>
          <Button variant={action ? "text" : "filled"} size="small" onClick={onClose}>
            {notice.confirmation_button}
          </Button>
          {action && (
            <Button variant="filled" size="small" href={action.url} target="_blank" onClick={onClose}>
              {action.label}
            </Button>
          )}
        </>
      )}
    >
      <NoticeText text={notice.text} />
    </Modal>
  );
}
